module.exports = __webpack_public_path__ + "img/promidia.ac922497.jpg";